import React from 'react';

import { ChatProps } from './index.types';
import { ChatView } from './index.view';

export function Chat(props: ChatProps) {
  return <ChatView {...props} />;
}
